module.exports = __webpack_public_path__ + "img/img_content.2aef6a9e.png";